import { render, staticRenderFns } from "./ContactFieldRow.vue?vue&type=template&id=763ba668&lang=pug"
import script from "./ContactFieldRow.vue?vue&type=script&lang=js"
export * from "./ContactFieldRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports